import { collection, getDocs, query, where } from 'firebase/firestore';
import { isTenantVisibleProperty } from './propertyLifecycle';

function toMillis(value) {
  const date =
    value?.toDate?.() ||
    (typeof value === 'number' ? new Date(value) : new Date(value || 0));
  const ms = date.getTime();
  return Number.isNaN(ms) ? 0 : ms;
}

export async function fetchTenantVisibleListings(db, { limitTo } = {}) {
  const kotenRef = collection(db, 'koten');
  const queries = [
    query(kotenRef, where('externalSource', '==', 'manual')),
    query(kotenRef, where('externalSource', '==', 'private')),
    query(kotenRef, where('externalSource', '==', 'website')),
    query(kotenRef, where('externalSource', '==', '')),
    query(kotenRef, where('externalSource', '==', null)),
    query(kotenRef, where('externalSource', '==', 'crm_integration'), where('crmPublished', '==', true)),
    query(kotenRef, where('externalSource', '==', 'crm_integration'), where('status', 'in', ['live', 'published']))
  ];

  const snapshots = await Promise.allSettled(queries.map((q) => getDocs(q)));
  const uniqueDocs = new Map();
  snapshots.forEach((result, index) => {
    if (result.status !== 'fulfilled') {
      console.warn(`tenantListings query ${index + 1} failed:`, result.reason?.message || result.reason);
      return;
    }
    result.value.forEach((docSnap) => uniqueDocs.set(docSnap.id, docSnap));
  });

  const now = Date.now();
  const listings = Array.from(uniqueDocs.values())
    .map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }))
    .filter(isTenantVisibleProperty)
    .sort((a, b) => {
      const aBoosted = a.boostActive && toMillis(a.boostExpiresAt) > now ? 1 : 0;
      const bBoosted = b.boostActive && toMillis(b.boostExpiresAt) > now ? 1 : 0;
      if (bBoosted !== aBoosted) return bBoosted - aBoosted;
      return toMillis(b.createdAt) - toMillis(a.createdAt);
    });

  return typeof limitTo === 'number' ? listings.slice(0, limitTo) : listings;
}
